<template>
  <a
    :class="[
      'hover:bg-white hover:text-black',
      { active: active },
      {
        'opacity-50 pointer-events-none touch-none cursor-not-allowed': disabled
      },
      item.additionalClass || ''
    ]"
    href="javascript:void(0)"
    @click="$emit('click', item)"
  >
    <base-icon
      :name="item.iconName"
      class="group-hover:text-sh-secondary-darken-75"
    />
    <span class="text-xs group-hover:text-sh-secondary-darken-75 md:block">
      {{ translate(item.label) }}
    </span>
  </a>
</template>

<script>
import tranlate from '../mixins/translate';
export default {
  name: 'NavigationItem',
  mixins: [tranlate],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  @apply block no-underline p-4 text-white text-center h-full;
}
a.active,
.active {
  @apply text-black bg-white;
}
span {
  @apply block;
  width: 100%;
}

@screen xs {
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  a {
    @apply px-3;
  }
}

@screen md {
  a {
    @apply p-4 w-auto;
  }
}
</style>
